import React from 'react';
import { createSelector } from 'reselect';
import { radioUI } from 'platform/forms-system/src/js/web-component-patterns';

const contactMethods = ['Email', 'Mobile Phone', 'Home Phone', 'Mail'];

const contactMethod = {
  uiSchema: {
    'view:contactMethodIntro': {
      'ui:description': (
        <h3 className="meb-form-page-only">
          Choose your contact method for follow-up questions
        </h3>
      ),
    },
    contactMethod: radioUI({
      title:
        'How should we contact you if we have questions about your application?',
      errorMessages: {
        required: 'Please select at least one way we can contact you.',
      },
      updateSchema: (() => {
        const filterContactMethods = createSelector(
          form => form?.contactInfo?.mobilePhone?.contact,
          form => form?.contactInfo?.homePhone?.contact,
          form => form?.contactInfo?.emailAddress,
          (mobilePhoneNumber, homePhoneNumber, email) => {
            const invalidContactMethods = [];

            if (!mobilePhoneNumber) {
              invalidContactMethods.push('Mobile Phone');
            }
            if (!homePhoneNumber) {
              invalidContactMethods.push('Home Phone');
            }
            if (!email) {
              invalidContactMethods.push('Email');
            }

            return {
              enum: contactMethods.filter(
                method => !invalidContactMethods.includes(method),
              ),
            };
          },
        );

        return form => filterContactMethods(form);
      })(),
    }),
  },
  schema: {
    type: 'object',
    properties: {
      'view:contactMethodIntro': {
        type: 'object',
        properties: {},
      },
      contactMethod: {
        type: 'string',
        enum: contactMethods,
      },
    },
    required: ['contactMethod'],
  },
};

export default contactMethod;
